import { WHATSAPP_URL, WHATSAPP_SMS_ENROLL_URL } from "@/config/site";

const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-28 px-6 bg-gradient-to-b from-stone-950 to-black"
    >
      <div className="max-w-3xl mx-auto text-center space-y-8">
        <div className="space-y-3">
          <span className="mono-tag text-xs uppercase tracking-widest text-amber-400">
            Membership Inquiries
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-stone-100 display-serif">
            Begin Your Edification
          </h2>
          <p className="text-sm text-stone-300 max-w-xl mx-auto leading-relaxed">
            We review applications for individual and corporate membership on an autonomous,
            merit-aligned basis. Direct your inquiry to the Institute council via WhatsApp.
          </p>
        </div>
        <div className="p-8 rounded-2xl bg-stone-900/90 border border-stone-800 space-y-6">
          <div className="text-xs text-stone-400 flex items-center justify-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500 pulse-glow"></span>
            Directorate Council Online for WhatsApp Admissions
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-cta"
              className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 rounded-xl bg-amber-500 hover:bg-amber-400 text-stone-950 font-bold text-base transition-colors shadow-xl hover:shadow-amber-500/25"
            >
              Start Conversation on WhatsApp
            </a>
            <a
              href={WHATSAPP_SMS_ENROLL_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-sms-enroll-cta"
              className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 rounded-xl border border-amber-500/60 text-amber-400 hover:bg-amber-500/10 font-bold text-base transition-colors"
            >
              Request SMS Ledger Enrollment
            </a>
          </div>
          <p
            data-testid="contact-whatsapp-consent-note"
            className="text-xs text-stone-400 leading-relaxed max-w-lg mx-auto"
          >
            SMS enrollment requests open WhatsApp with your consent statement pre-written: you
            agree to receive ledger alert text messages at your mobile number. The council replies
            with one confirmation request — reply YES to confirm and activate. Reply STOP to cancel
            at any time.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="/assets/bmex-onboarding.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-agreement-download"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-stone-700 text-stone-300 hover:border-amber-600/60 hover:text-amber-300 text-sm font-semibold transition-colors"
            >
              Read the Merchant Exchange Participation Agreement (PDF)
            </a>
            <a
              href="/assets/sms-consent-addendum.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-sms-addendum-download"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-stone-700 text-stone-300 hover:border-amber-600/60 hover:text-amber-300 text-sm font-semibold transition-colors"
            >
              SMS Consent Addendum (PDF)
            </a>
          </div>
          <p className="text-[11px] text-stone-400">
            Strict privacy maintained. The Bourganization Institute does not sell, track, or share
            member contact records.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
